import React from 'react';
import { modal as modalStore } from 'store';
import { Container } from 'components/UI';
import { Title, Button } from '@landing/ui';
import { eventsData } from 'define';

import * as styles from './Events.module.scss';

export default function Events({ title, description, items }) {
  const callModal = initialEvent => {
    modalStore.open('request-consultation', { initialEvent });
  };

  return (
    <Container id="events">
      <div className={styles.layout}>
        <Title color="white">{title}</Title>
        <p className={styles.description}>{description}</p>
        <div className={styles.items}>
          {items.map(({ title: name, description: subtitle }) => {
            const eventDate = new Date(eventsData[name].date);
            const isPastEvent = eventDate <= new Date();
            const dateOptions = { day: 'numeric', month: 'short', timeZone: 'Europe/Warsaw' };
            const time = eventsData[name].time;
            return (
              <div key={name} className={styles.item}>
                <div className={styles.schedule}>
                  <div className={styles.date}>
                    {eventDate.toLocaleDateString('en-GB', dateOptions)}
                  </div>
                  <div className={styles.time}>{time}</div>
                  {isPastEvent && <div className={styles.label}>Past</div>}
                </div>
                <div className={styles.content}>
                  <div className={styles.text}>
                    <h4 className={styles.itemTitle}>{name}</h4>
                    <p className={styles.itemDescription}>{subtitle}</p>
                  </div>
                  {!isPastEvent && (
                    <Button
                      className={styles.button}
                      onClick={() => callModal(name)}
                      theme="transparentBg"
                      fullWidthMobile
                    >
                      Register for Event
                    </Button>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </Container>
  );
}
